module.exports = __webpack_public_path__ + "static/material-leather.51b31b95.svg";